// src/components/Footer.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = ({style}) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer
      className="main-footer"
      style={{ display: "flex", justifyContent: "space-between" ,background:"#DFDCD7",...style,}}
    >
      <div className=" d-none d-sm-block">
        Copyright &copy; {currentYear}. All rights reserved.
      </div>
      <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
       <span> Powered By</span>
        <a href="http://www.mindzcube.com">
          <img
            src="/img/mindzcube.png"
            height="30px"
            alt="Mindzcube"
            // style={{ marginLeft: "15px" }}
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
